import { createContext, useContext, useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { MENU_GROUPS } from '../data/nav';
import './mobileNav.css';

const MobileNavContext = createContext({ open: false, setOpen: () => {} });

export function MobileNavProvider({ children }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setOpen(false); }, [location.pathname]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return <MobileNavContext.Provider value={{ open, setOpen }}>{children}</MobileNavContext.Provider>;
}

export function useMobileNav() {
  return useContext(MobileNavContext);
}

export function MobileNavSheet() {
  const { open, setOpen } = useMobileNav();
  if (!open) return null;

  return (
    <>
      <div className="mnav-backdrop" onClick={() => setOpen(false)} aria-hidden="true" />
      <nav id="mobile-nav-sheet" className="mnav-sheet" aria-label="Site menu">
        <div className="mnav-groups">
          {MENU_GROUPS.map(g => (
            <div key={g.label} className="mnav-group">
              <h2 className="label mnav-h">{g.label}</h2>
              <ul>
                {g.links.map(l => (
                  <li key={l.to}>
                    <NavLink
                      to={l.to}
                      end
                      className={({ isActive }) => `mnav-link${isActive ? ' active' : ''}`}
                      onClick={() => setOpen(false)}
                    >
                      {l.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mnav-foot">
          <a href="https://vigilhold.com/register" className="btn btn-primary" target="_blank" rel="noopener noreferrer">
            Start a Vigilhold trial <span aria-hidden="true">↗</span>
          </a>
          <a href="https://vigilhold.com/lab" className="link-arrow" target="_blank" rel="noopener noreferrer">
            See the live lab <span aria-hidden="true">↗</span>
          </a>
          <p className="label">14-day trial · no card · from $39/mo · <a href="tel:+18338219853">833-821-9853</a></p>
        </div>
      </nav>
    </>
  );
}

export function MobileTabBar() {
  const { open, setOpen } = useMobileNav();
  const close = () => setOpen(false);
  const tab = ({ isActive }) => `mtab${isActive && !open ? ' active' : ''}`;

  return (
    <nav className="mtabbar" aria-label="Quick navigation">
      <NavLink to="/" end className={tab} onClick={close}>Home</NavLink>
      <NavLink to="/products" className={tab} onClick={close}>Products</NavLink>
      <a href="https://vigilhold.com" className="mtab mtab-primary" target="_blank" rel="noopener noreferrer">
        Vigilhold <span aria-hidden="true">↗</span>
      </a>
      <NavLink to="/blog" className={tab} onClick={close}>Blog</NavLink>
      <button
        type="button"
        className={`mtab${open ? ' active' : ''}`}
        aria-expanded={open}
        aria-controls="mobile-nav-sheet"
        onClick={() => setOpen(!open)}
      >
        {open ? 'Close' : 'Menu'}
      </button>
    </nav>
  );
}
